export default {
  en: {
    title: ""
  },
  pl: {
    projects2024: {
      projectsTitle: "Projekty 2025",
      title:
        "<span style='color: #c4e230'>Czy wiesz jak wiele można zmienić</span> w ciągu jednej doby?</br>My wiemy!",
      summary: "<span>Uczestnicy stworzyli niezwykłe projekty. Trzymamy dalej kciuki za podbijanie świata, bo projekty (i zespoły!) mają potencjał! <br/> Oto najlepsze z nich:</span>",
      winners:
      {
        name: "Karakeniary z projektem Ściana Ogniowa",
        text:
          "Ściana Ogniowa to system wspierający zarządców lasów i instytucje odpowiedzialne za ograniczanie ryzyka pożarowego, która integruje dane z dronów, satelitów i rejestrów publicznych, by w czasie rzeczywistym przewidywać i monitorować ryzyko pożarów lasów. Aplikacja mobilna ostrzega turystów przed wejściem w zagrożone strefy, a panel analityczny wspiera zarządców np. Lasy Państwowe podpowiedziami działań prewencyjnych. System ogranicza straty środowiskowe i finansowe, redukując koszty akcji gaśniczych.",
        place: "I MIEJSCE oraz nagroda uczestników"
      },
      winners2:
      {
        name: "Carotly z projektem GarboGo!",
        text:
          "Aplikacja GarboGo to funkcjonalne narzędzie, które łączy w sobie pasję do sportu oraz pomaga zadbać o środowisko naszej planety. Jest dedykowana zarówno indywidualnym użytkownikom, jak i przedsiębiorcom, którzy chcą zaangażować swoją społeczność w działania na rzecz planety oraz oderwać się od ekranu laptopa. Dodatkową formą motywacji są zbierane carrotcoiny, które uczestnicy gromadzą w aplikacji i mogą wymieniać na bonusy, takie jak darmowe bilety na komunikację miejską, zniżki w sklepach promujących ekologiczną żywność czy w sklepach sportowych. Aplikacja GarboGo nie tylko motywuje społeczność do zbierania śmieci czy wybierania roweru jako środka transportu, ale też – dzięki danym, które gromadzi – jest źródłem informacji dla gmin i powiatów o tym, które miejsca w przestrzeni publicznej wymagają szczególnej uwagi pod kątem zaśmiecenia.",
        place: "II MIEJSCE",
      },
        winners3:
      {
        name: "Optymistki z projektem Messa",
        text:
          "Messa to gra terenowa, która ożywia zapomniane legendy Pojezierza Iławskiego. Przemierzaj szlaki pełne opowieści, rozwiązuj zagadki i zdobywaj nagrody – zniżki, atrakcje, wspomnienia. To więcej niż aplikacja – to przygoda, która łączy ludzi z historią, naturą i lokalną społecznością. Odkrywaj. Czuj. Wspieraj. #poRybkęNiePoMedal",
        place: "III MIEJSCE",
      },
      projects: [
        {
          name: "Sustainasisters z projektem Pokaż mi jak to się robi",
          text:
            "„Pokaż mi jak to się robi” to wielopokoleniowa gra planszowa z kartami wyzwań: Opowiedz mi – podziel się historią, Pokaż mi – zademonstruj krok po kroku, Wykonaj samodzielnie oraz Udowodnij prawdę/fałsz. To angażująca i edukacyjna forma wspólnego spędzania czasu, która pomaga budować świadomość ekologiczną oraz wzmacnia rodzinne więzi, tworząc cenne wspomnienia w realnym świecie. Gra stanowi wartościową alternatywę dla nadmiaru bodźców wzrokowo-słuchowych i cyfryzacji wolnego czasu. Uczestnicy uczą się od siebie nawzajem i inspirują do pozytywnych zmian w swoim otoczeniu. Dostępna jest w wersjach: Print & Play, on-demand, Senior Friendly oraz premium. Gra wykonana jest z falistej tektury w 100% z recyklingu, co podkreśla jej ekologiczny charakter.",
          place: "WYRÓŻNIENIE",
          posX: "30px",
          posY: "50px"
        },
        {
          name: "magnetoField z projektem SmokCheck",
          text:
            "Produkt konsumencki z kategorii elektronika konsumencka wellbeing.",
          place: "WYRÓŻNIENIE",
          posX: "30px",
          posY: "50px"
        }
      ]
    },
    data2025: {
      title: "Efekty 2025",
      description: `<p>Hackathon odbył się 2-4 czerwca 2023 roku w formie hybrydowej - w Gdańskim Parku Naukowo - Technologicznym, W Słupskim Inkubatorze Technologicznym oraz online. W wydarzeniu uczestniczyło ok. 150 osób (uczestnicy, mentorzy, eksperci). Wszyscy podjęli się wyzwania, aby w 48 godzin stworzyć projekty wyjątkowe, nowoczesne technologicznie oraz bardzo potrzebne ludziom i naszej planecie.
        </p><br/><p>W ramach wydarzeń wokół  Hack4change, odbył się także  wspólny spływ kajakowy po rzece Reda, wraz ze sprzątaniem terenu wokół spływu. Ponadto w Słupskim Inkubatorze Technologicznym zorganizawliśmy warsztaty z robotyki dla dzieci oraz warsztaty Life Plan Academy dla młodzieży.</p>`,
    },
    partners2025: {
      title: "Partnerzy 2025",
      description: "Chcesz wesprzeć inicjatywę oferując swoją wiedzę i talent lub dostęp do danych? Napisz do nas! Przygotujemy dla Ciebie ofertę współpracy i razem zrobimy coś dobrego. Bądź częścią zmiany!",
      button: "Wypełnij formularz &rarr;",
      boxTitle: "Dołącz do nas",
      organizers: {
        title: "Organizatorzy 2025",
        logos: [
          {
            title: " ",
            elements: [
              {
                image:
                  require("../Partners/images/PODSTAWOWA codeme_logo_black_red_subtitle_black_rgb.png").default,
                url: "http://codeme.pl/",
              },
              {
                image: require("../Partners/images/LOGO_KA_gold-01.jpg").default,
                url: "https://kaminskiacademy.com/",
              },
              {
                image: require("../Partners/images/urzadpom.png").default,
                url: "https://pomorskie.eu/urzad-marszalkowski-wojewodztwa-pomorskiego/",
              },
              {
                image: require("../Partners/images/Pomorskie_Kompetencje_Jutra_LOGO_1-01.jpg").default,
                url: "https://gospodarka.pomorskie.eu/kategoria/pomorskie-kompetencje-jutra/",
              },
              {
                image: require("../Partners/images/ikm.jpg").default,
                url: "https://ikm.gda.pl/",
              },
              {
                image:
                  require("../Partners/images/hevelianum_logo.png").default,
                url: "https://hevelianum.pl/",
              },
            ]
          },
        ],
      },
      partners: {
        title: "Partnerzy 2025",
        logos: [
          {
            title: "PARTNER SEKTORA PUBLICZNEGO",
            elements: [
              {
                image:
                  require("../Partners/images/ministerstwo_cyfryzacji.png").default,
                url: "https://www.gov.pl/web/cyfryzacja",
              },
            ],
          },
          {
            title: "Bronze Partner:",
            elements: [
              {
                image:
                  require("../Partners/images/HL-F_Euro_4c.svg").default,
                url: "https://www.hapag-lloyd.com/en/home.html",
              },
            ],
          },
          {
            title: "Partnerzy merytoryczni:",
            elements: [
              {
                image: require("../Partners/images/SWPS_University.svg.png").default,
                url: "https://www.swps.pl/",
              },
              {
                image: require("../Partners/images/PJATK_shop-1.png").default,
                url: "https://pja.edu.pl/",
              },
              {
                image: require("../Partners/images/logo_gs.svg").default,
                url: "https://g-s.pl/",
              },
              {
                image: require("../Partners/images/StowarzyszenieProducentówPolskiejAnimacji.jpg").default,
                url: "https://sppa.pl/",
              },
              {
                image: require("../Partners/images/plus_jeden.svg").default,
                url: "https://plusjeden.com/",
              },
              {
                image: require("../Partners/images/GPNT.png").default,
                url: "https://gpnt.pl/",
              },
              {
                image: require("../Partners/images/rsz_interizon.jpg").default,
                url: "https://interizon.pl/pl/",
              },
              {
                image: require("../Partners/images/KAINOS.png").default,
                url: "https://kainos.pl/",
              },
              {
                image: require("../Partners/images/yellow_tie.webp").default,
                url: "https://yellowtie.pl/",
              },
              {
                image: require("../Partners/images/Neoteric.webp").default,
                url: "https://neoteric.eu/",
              },
              {
                image: require("../Partners/images/FenixMind.webp").default,
                url: "https://fenixmind.pl/",
              },
              {
                image: require("../Partners/images/youbloom.webp").default,
                url: "https://youbloom.pl/",
              },
              {
                image: require("../Partners/images/okiem-stratega.webp").default,
                url: "https://okiemstratega.pl/",
              },
              {
                image: require("../Partners/images/m4h.webp").default,
                url: "https://me4health.pl/",
              },
              {
                image: require("../Partners/images/catboat.png").default,
                url: "https://www.linkedin.com/company/catboat-strings/about/",
              },
              {
                image: require("../Partners/images/icutech.webp").default,
                url: "https://www.icutech.pl/",
              },
              {
                image: require("../Partners/images/resqvest.svg").default,
                url: "https://www.linkedin.com/company/resqvest/about/",
              },
              {
                image: require("../Partners/images/jogowaga-logo.jpeg").default,
                url: "https://www.facebook.com/jogowaga",
              },
              {
                image: require("../Partners/images/ZU.webp").default,
                url: "https://zut.com.pl/",
              },
              {
                image: require("../Partners/images/DG_logo_mid_res.jpg").default,
                url: "https://www.facebook.com/RyczelDobrzeGada/",
              },
              {
                image: require("../Partners/images/rust.webp").default,
                url: "https://www.startupharbour.pl/",
              },
            ],
          },
          {
            title: "Partnerzy medialni i społecznościowi:",
            elements: [
              {
                image:
                  require("../Partners/images/wakacjepl.png").default,
                url: "https://www.wakacje.pl/",
              },
              {
                image: require("../Partners/images/ECD_logo.jpg").default,
                url: "https://fundacjaecd.pl/",
              },
              {
                image: require("../Partners/images/rsz_logo_rgb.png").default,
                url: "https://www.trojmiasto.pl/",
              },
              {
                image: require("../Partners/images/rsz_gdansk_www_falka.png").default,
                url: "https://www.gdansk.pl/",
              },
              {
                image: require("../Partners/images/zielona-gospodarka-logo.png").default,
                url: "https://zielonagospodarka.pl/",
              },

              {
                image: require("../Partners/images/magazyn_pomorski.png").default,
                url: "https://www.magazynpomorski.eu/",
              },
              {
                image: require("../Partners/images/logo-ngo.png").default,
                url: "https://www.ngo.pl/",
              },
              {
                image: require("../Partners/images/logo-PW.png").default,
                url: "https://www.pw.edu.pl/",
              },
              {
                image: require("../Partners/images/pp.jpg").default,
                url: "https://pracodawcypomorza.pl/",
              },
            ],
          },
          {
            title: "Partnerzy wspierający:",
            elements: [

              {
                image: require("../Partners/images/logo Beka.jpg").default,
                url: "https://www.facebook.com/p/Rezerwat-Przyrody-Beka-100067406709172/",
              },
              {
                image: require("../Partners/images/bat.jpg").default,
                url: "https://bat.pl/",
              },
              {
                image: require("../Partners/images/kosakowo_logo_CMYK (1).png").default,
                url: "https://gminakosakowo.pl/",
              },
              {
                image: require("../Partners/images/logo_WODY-POLSKIE_pl-poziom.jpg").default,
                url: "https://www.gov.pl/web/wody-polskie/",
              },

              {
                image: require("../Partners/images/logo_PZW_z_R.jpg").default,
                url: "https://pzw.gda.pl/",
              },
              {
                image: require("../Partners/images/kajaki_3.jpg").default,
                url: "https://www.facebook.com/kajaki3miasto/",
              },
              {
                image: require("../Partners/images/kajaki.png").default,
                url: "https://www.kajakowemeandry.pl/",
              },
              {
                image: require("../Partners/images/czarne_wiosła.svg").default,
                url: "https://www.czarnewiosla.pl/",
              },
              {
                image: require("../Partners/images/logo-edufun.png").default,
                url: "https://edufun.pl/",
              },
              {
                image: require("../Partners/images/otop.png").default,
                url: "https://otop.org.pl/",
              },
              {
                image: require("../Partners/images/peko2.jpg").default,
                url: "https://pukpeko.pl/",
              },
              {
                image: require("../Partners/images/REDA-LOGO.jpg").default,
                url: "https://miasto.reda.pl/",
              },
              {
                image: require("../Partners/images/wejherowo.png").default,
                url: "https://www.powiatwejherowski.pl/",
              },
              {
                image: require("../Partners/images/puck.png").default,
                url: "https://gmina.puck.pl/",
              },
            ],
          },
        ],
      },
      partners2024Others: {
        logos: [
          {
            title: " ",
            elements: [
              // {
              //   image: require("./images/POMORSKIE-kolor-RGB.png").default,
              //   url: "https://pomorskie.eu/",
              // },
              // {
              //   image: require("./images/ISP_kolor.jpg").default,
              //   url: "https://pomorskie.eu/smart-progress/",
              // }
            ],
          },
        ],
      }
    },
    mentors2025: {
      title: "Mentorzy i eksperci 2025",
      button: "Zobacz więcej &rarr;",
      mentors: [
        {
          id: "marcin",
          image: require("../Mentors/images/marcin_m.jpeg").default,
          name: "Marcin Młyński",
          description:
            "Entuzjasta nowych technologii, koncepcji Internet of Things oraz świata startupów. Koordynator wielu biznesowych wydarzeń dla setek osób oraz organizator kilkudziesięciu hackathonów. Co-founder & CEO CODE:ME, jednej z największych polskich szkół programowania oraz założyciel HACKER:SPACE Trójmiasto, otwartej technologicznej przestrzeni, poświęconej tworzeniu i rozwojowi innowacyjnych projektów. Hackerspace Trójmiasto jest obecnie jedną z największych technologicznych społeczności w północnej Polsce. Uczestnik PFR School of Pioneers, realizowanego we współpracy z University of Cambridge, międzynarodowego programu dedykowanego przedsiębiorcom i wizjonerom w obszarze nowych technologii.",
          title: "CEO, CODE:ME, Founder Hackerspace Trójmiasto",
          linkedin: "https://www.linkedin.com/in/marcin-mlynski/",
        },
        {
          image: require("../Mentors/images/rsz_marek_kaminski.jpg").default,
          name: "Marek Kamiński",
          description:
            "Zdobywca biegunów, założyciel Fundacji i Kaminski Academy. Jako pierwszy na świecie zdobył oba bieguny Ziemi w ciągu jednego roku, bez pomocy z zewnątrz, za co został wpisany do Księgi Rekordów Guinnessa. Inspiruje setki tysięcy ludzi w Polsce i na świecie poprzez książki, filmy, podcasty, webinary i programy trenerskie.\n" +
            "Stworzył Kamiński Academy, której misją jest promowanie wiary w potencjał ludzki i budowanie odporności psychicznej. Daje sprawdzone narzędzia do zmiany i osiągania celów, które od 20 lat zmieniają życie dziesiątek tysięcy ludzi i pomagają w rozwoju osobistym i biznesowym.  \n" +
            "Założyciel Fundacji oraz pomysłodawca międzynarodowego programu transformacyjno-rozwojowego Life Plan Academy dla młodzieży w wieku 14-17 lat, którego celem jest zmiana jakości życia, zapobieganie depresji i budowa własnej wartości, poprzez naukę osiągania indywidualnych celów.\n" +
            "<br/><br/>Aby dowiedzieć się więcej odwiedź: <br/>" +
            "<a href='https://marekkaminskiacademy.com/'>Kaminski Academy</a><br/>" +
            "<a href='https://fundacjamarkakaminskiego.com/'>Fundacja Marka Kaminskiego</a>",
          title:
            "Zdobywca biegunów, Innowator, Twórca Metody Biegun, Kaminski Academy",
          linkedin: "https://pl.linkedin.com/in/kaminskimarek1"
        },
        {
          image: require("../Mentors/images/sergiuszr.png").default,
          name: "Sergiusz Ryczel",
          description:
            "Uczę zachowania przed kamerą, na scenie, w kontakcie z mediami📺 Generalnie pomagam i uczę mówić tak by było ciekawie i by przekazać to co najważniejsze. By nie gubić swoich szans. ",
          title:
            "Trener Medialnych Wystąpień Publicznych🎤Dwujęzyczny Konferansjer🇬🇧 Mówca/Keynote Speaker🎙Konsultant Video Marketingu(EB,EA)🎥Konsultant Marki Osobistej🎩",
          linkedin: "https://www.linkedin.com/in/sergiusz-ryczel/",
        },
        {
          id: "magdak",
          image: require("../Mentors/images/magdak.jpg").default,
          name: "Magda Kwoska",
          description: "Magda posiada doświadczenie w rozwijaniu oraz wdrażaniu innowacji technologicznych. Od kilkunastu lat wspiera powstawanie i rozwój nowych rozwiązań, zarówno wewnątrz korporacji jak i startupów. Jest zaangażowana we wsparcie mentoringowe dla startupów jak i przedsiębiorstw społecznych. \n" +
            "Magda zajmowała się w PwC współpracą ze startupami prowadząc program akceleracyjny Startup Collider a obecnie zajmuje się programem innowacji pracowniczych PwC Innovation@Poland. Prowadziła także inkubatory społeczne, programy grantowe realizowane dla Ministerstwa Rozwoju, we współpracy z organizacjami pozarządowymi, które miały na celu wsparcie innowacyjnych pomysłów społecznych.\n" +
            "Prowadziła również program akceleracyjny dla startupów dla funduszu VC oraz stała po drugiej stronie - prowadząc swój startup.\n" +
            "Zajmowała się Business Developmentem w startupie iTaxi, wprowadzała nową markę na rynek - Socatots, ogólnoświatową sieć szkółek oferujących zajęcia ogólnorozwojowe dla małych dzieci.\n" +
            "Z wykształcenia farmaceutka, która w pewnym momencie postanowiła zmienić swoją karierę zawodową.\n",
          title: "Innovation Manager at PwC Polska",
          linkedin: "https://www.linkedin.com/in/mkwoska/"
        },
        {
          id: "mp",
          image: require('../Mentors/images/rsz_coming_soon.png').default,
          name: "Marcin	Pietruszewski",
          description: `Od ponad 20 lat związany z administracją publiczną. Obecnie skoncentrowany na projektach strategicznych związanych z GovTechem i transformacją cyfrową w administracji publicznej. Wspiera inicjatywy z zakresu Smart City/Smart Village, nowoczesnych technologii oraz cyfryzacji usług publicznych, które realnie wpływają na jakość życia obywateli.`,
          title: "Ministerstwo Cyfryzacji	Naczelnik Wydziału",
          linkedin: "https://www.linkedin.com/in/marcin-pietruszewski-183b5232b/",
        },
        {
          id: "mateuszb",
          image: require("../Mentors/images/mateuszb.jpg").default,
          name: "Mateusz Bartoszewski",
          description: `Mateusz Bartoszewski, absolwent Wydziału Biologii UG.
Z wykształcenia biolog-parazytolog, który zgłębiał tajniki życia kleszczy. Obecnie zawodowo związany z Hevelianum, gdzie zajmuje się popularyzacją nauki i edukacją ekologiczną. W swojej pracy szczególnie mocno przygląda się przyrodzie Góry Gradowej i gdańskiego Brzeźna, a w kręgu jego największych zainteresowań znajdują się owady, rosnące tam „chwasty” i wodne stworzenia, które można spotkać w akwariach Hevelianum. W wolnych chwilach zwiedza inne światy podczas sesji RPG, wytęża mózg podczas grania w planszówki lub relaksuje się malując figurki do wyżej wymienionych.`,
          title: "Specjalista ds. Edukacji Ekologicznej w Hevelianum",
          linkedin: "https://www.linkedin.com/in/mateusz-bartoszewski-296b81197/",
        },
        {
          id: "angelikao",
          image: require("../Mentors/images/angelikao.webp").default,
          name: "Angelika Ostasiewicz",
          description: `Specjalistka ds. angażowania społeczności w rozwój innowacji, od ponad pięciu lat związana z administracją publiczną. Od czterech lat aktywnie rozwija polski sektor GovTech, wspierając współpracę administracji z biznesem. Posiada doświadczenie w komunikacji, marketingu oraz zarządzaniu projektami. Absolwentka Uniwersytetu Łódzkiego i Szkoły Głównej Handlowej w Warszawie. Jej mocne strony – organizacja i kreatywność – przekładają się na skuteczną realizację innowacyjnych inicjatyw.`,
          title: "Specjalistka ds. angażowania społeczności w rozwój innowacji",
          linkedin: "https://www.linkedin.com/in/angelikaostasiewicz/",
        },
        {
          id: "joannak",
          image: require("../Mentors/images/Joanna Kotowicz.jpg").default,
          name: "Joanna Kotowicz",
          description:
            "Menedżerka z 15-letnim doświadczeniem w obszarach inwestycji i rozwoju, pracująca w organizacjach na podstawie modelu rozwojowego ESG. Zwolenniczka transformacji energetycznej i zero waste. Współpracowała z sektorem energetycznym i produkcyjnym. Obecnie menedżerka w PKO Bankiem Polskim, gdzie wspiera przedsiębiorstwa w zakresie zrównoważonego rozwoju i finansowania zielonych inwestycji. Absolwentka Collegium Civitas w Warszawie, Politechniki Gdańskiej oraz Akademii Marynarki Wojennej. Ukończyła studia MBA Zarządzanie Polityką Energetyczną i Klimatyczną.",
          title: "MBA in energy and climate I Future Oriented Person | Zero-emission Oriented Manager | Sustainability Expert",
          linkedin: "https://www.linkedin.com/in/joannakotowicz/",
        },
        {
          id: "annas",
          image: require("../Mentors/images/annas.webp").default,
          name: "Anna Supernat",
          description: `Dr hab. Anna Supernat - Liderka grupy badawczej w Zakładzie Onkologii Translacyjnej Gdańskiego Uniwersytetu Medycznego
Kierownik Centrum Analiz Biostatystycznych i Bioinformatycznych Gdańskiego Uniwersytetu Medycznego
Dr hab. Anna Supernat jest absolwentką Międzyuczelnianego Wydziału Biotechnologii Uniwersytetu Gdańskiego i Gdańskiego Uniwersytetu Medycznego, gdzie uzyskała stopień naukowy doktora w Zakładzie Biologii Komórki pod opieką prof. Anny Żaczek. Staż podoktorski odbyła w latach 2015–2016 w Cancer Research UK Cambridge Institute (University of Cambridge), a następnie udała się na miesięczny staż badawczy w Cancer Center Amsterdam (Amsterdam UMC).
Głównym obszarem badań Anny Supernat są płynne biopsje w nowotworach, ze szczególnym uwzględnieniem raka jajnika, z naciskiem na poprawę diagnostyki i monitorowania postępu choroby. Zespół działający w Zakładzie Onkologii Translacyjnej Gdańskiego Uniwersytetu Medycznego wykorzystuje najnowocześniejsze, wysokoporzepustowe techniki biologii molekularnej do analizy próbek od pacjentów. Coraz większe znaczenie w analizie tak wielowymiarowych danych odgrywa uczenie maszynowe, a prowadzone badania dynamicznie rozwijają się w kierunku multiomiki, by uchwycić pełniejszy obraz biologii nowotworów.
Anna Supernat ściśle współpracuje z zespołami naukowymi z University of Utah (USA) oraz Cancer Center Amsterdam (Holandia). Była ekspertem Narodowego Centrum Badań i Rozwoju w latach 2018–2019 oraz analitykiem genetycznym w firmie MNM Diagnostics Sp. z o.o. w 2019 roku. Jest laureatką licznych nagród i stypendiów, w tym: Stypendium START oraz STAŻE Fundacji na rzecz Nauki Polskiej, Grantu Darboven Idee Grant, Stypendium Ministra Nauki i Szkolnictwa Wyższego, a także programów POMOST i Innodoktorant. Kierowała grantami NCN Sonata oraz NCBiR Lider, a także reprezentowała Gdański Uniwersytet Medyczny w finansowanym przez UE konsorcjum EIT HEI „innovAId”, którego celem było rozwijanie kompetencji przedsiębiorczych w dziedzinie medycyny cyfrowej.
Jest współautorką 33 recenzowanych publikacji naukowych, 2 artykułów popularnonaukowych oraz 2 rozdziałów w książkach. Prywatnie – mama trzech fantastycznych synów i pasjonatka przygód, zarówno naukowych, jak i życiowych.`,
          title: "Naukowiec, Kierownik Centrum Analiz Biostatystycznych i Bioinformatycznych",
          linkedin: "https://pl.linkedin.com/in/anna-supernat-61749891",
        },
        {
          id: "karinar",
          image: require("../Mentors/images/karinar.webp").default,
          name: "Karina Rojek",
          description: `Koordynatorka projektu Medialab Gdańsk w Instytucie Kultury Miejskiej, który łączy kulturę, aktywizm społeczny, edukację i technologię. Tworzy przestrzeń dla eksperymentu i współpracy, dzielenia się wiedzą, szukania rozwiązań. Działa na rzecz odpowiedzialnego wykorzystania nowych mediów i technologii dla rozwoju kultury i rozwoju społecznego.  
Interesuje mnie także odkrywanie tożsamości miasta Gdańska i jego mieszkańców i mieszkanek poprzez poznawanie przeszłości zapisanej we wciąż niezbadanych przepastnych archiwach… szczególnie cyfrowych.  
Redaktorka serwisu popularyzującego domenę publiczną oraz biblioteki cyfrowe – <a href="https://www.szukamy.org" target="_blank">www.szukamy.org</a>. Angażuje się w upowszechnianie korzystania z otwartych zasobów w edukacji oraz w propagowanie idei otwartych instytucji kultury.  
`,
          title: "Koordynatorka Medialabu w gdańskim Instytucie Kultury Miejskiej",
          linkedin: "https://www.linkedin.com/in/karina-rojek-89848b83/",
        },
        {
          id: "radoslaww",
          image: require("../Mentors/images/radoslaww.jpg").default,
          name: "Radosław Wika",
          description:
            "Z wykształcenia ekonomista, posiada kilkunastoletnie doświadczenie w branży finansowej potwierdzone realizacją kilkudziesięciu projektów inwestycyjnych oraz doświadczeniem w zarządzaniu zespołami projektowymi. Ekspert w zakresie pozyskiwania funduszy, w tym europejskich. Praktyk w transferze technologii oraz w realizacji projektów B+R. Obecnie pełni obowiązki Dyrektora Gdańskiego Parku Naukowo-Technologicznego oraz jest członkiem Rady Pomorskiego Klastra ICT Interizon.",
          title: "Dyrektor Gdańskiego Parku Naukowo - Technologicznego",
          linkedin: "https://www.linkedin.com/in/rados%C5%82aw-wika-76a3b788/",
        },
        {
          id: "ewak",
          image: require("../Mentors/images/Ewa Kryger.jpg").default,
          name: "Ewa Kryger",
          description:
            "Dociekliwa specjalistka Data Science oraz artystka. Z wykształcenia urbanistka i filozofka. Wiele lat pracowała przy projektach planistycznych, partycypacyjnych i edukacyjnych. Skupia się głównie na wizualizacji i analizie procesów zarówno biznesowych, jak i społecznych. Dodatkowo bardzo ważna jest dla niej praca społeczna i wykorzystanie nowych technologii w zakresie AI for Good. Aktywnie działa w obszarze 3 sektora, współzałożycielka WiMLDS (Women in Machine Learning & Data Science) Trójmiasto. Założycielka Fundacji Art Hacks AI, której główną misją będzie tłumaczenie zagadnień związanych z nowymi technologiami, językiem emocji poprzez sztukę. W wolnym czasie, gdy nie czyta, to maluje, zwiedza świat na rowerze oraz tworzy muzykę.",
          title: "Delivery Management in AI | TOP100 Women in Data Science | Project Management | Team-building Facilitation | Art Meditation | AI Ethics | Art Tech",
          linkedin: "https://www.linkedin.com/in/ewakryger/",
        },
        {
          id: "lukaszp",
          image: require("../Mentors/images/lukaszp.jpg").default,
          name: "Łukasz Pelowski",
          description:
            "Manager z 20 letnim doświadczeniem w zarządzaniu małymi i średnimi przedsiębiorstwami.\n" +
            "Specjalizuje się w planowaniu i wdrażaniu strategii rozwoju, negocjacjach oraz budowaniu wartości firmy.\n" +
            "Pierwszą działalność założył na studiach. Później stworzył, dopracował i rozwijał wiele idei biznesowych o  o zróżnicowanym profilu.\n" +
            "Obecnie zaangażowany w rozwój spółek Secret Garden Group i Biuro56, inwestuje także na giełdzie.\n" +
            "Prywatnie kocha boks, wspinaczkę i podróże. Ponadto lubi czytać i uczyć się języków obcych.\n" +
            "Entuzjasta dynamicznego podejścia do życia.",
          title: "General Director at SGG | Value investor | Mentor | Akademia Leona Koźmińskiego",
          linkedin: "https://www.linkedin.com/in/%C5%82ukasz-pelowski-79089020/",
        },

        {
          id: "jaroslaw",
          image: require("../Mentors/images/rsz_jaroslaw_p.jpg").default,
          name: "Jarosław Parzuchowski",
          description:
            "Prezes Zarządu Klastra Interizon, największej na Pomorzu instytucji otoczenia biznesu z branży ICT. Pełni także funkcję Przewodniczącego Rady Inteligentnej Specjalizacji Pomorza „Technologie Interaktywne w środowisku nasyconym informatycznie”. Jest członkiem dwóch interdyscyplinarnych zespołów badawczych w ramach Programu Operacyjnego Polska Cyfrowa, realizujących systemy informatyczne dla branży medycznej m.in. narzędzia do tworzenia modeli 3D z danych radiologicznych.",
          title: "CEO, Interizon: Pomorski Klaster ICT",
          linkedin: "https://www.linkedin.com/in/jaroslaw-parzuchowski-3b37b8a1",
        },
        {
          id: "tvd",
          image: require('../Mentors/images/tvd.jpg').default,
          name: "Tran Vinh Do",
          description: `Administrator w Departamencie GovTech Polska w Ministerstwie Cyfryzacji, specjalizujący się w tematyce smart city.`,
          title: "Administrator, Government Technology (GovTech)",
          linkedin: "https://www.linkedin.com/in/tranvinhdo/",
        },
        {
          id: "jk",
          image: require('../Mentors/images/juliak.webp').default,
          name: "Julia Kostro",
          description: `Ekspertka od pracy koncepcyjnej, GovTechu i łączenia kropek. Ekspertka od pracy koncepcyjnej, GovTechu i łączenia kropek. Na co dzień działam w świecie innowacji publicznych – wiem, z jakimi wyzwaniami mierzy się administracja i gdzie szukać insightów, które prowadzą do rozwiązań mających realny sens. Pomagam przekładać potrzeby instytucji na język technologii i łączyć je z energią oraz kreatywnością środowiska innowatorów.`,
          title: "Ekspertka | GovTech",
          linkedin: "https://www.linkedin.com/in/juliakostro",
        },
        {
          id: "miroslaw",
          image: require("../Mentors/images/rsz_mirek_p.jpg").default,
          name: "Mirosław Pałysiewicz",
          description:
            `Jestem ekspertem z wieloletnim doświadczeniem w obszarze technologii informatycznych (IT) oraz nowoczesnych technologii produkcyjnych, takich jak druk 3D, elektronika i IoT. Moja kariera łączy dwa kluczowe nurty działalności: zarządzanie projektami i testowanie w IT oraz popularyzację i rozwój technologii addytywnych oraz inteligentnych systemów wytwarzania. Moja misja to wspieranie firm i instytucji w implementacji innowacyjnych rozwiązań technologicznych, które napędzają rozwój oraz zwiększają konkurencyjność na rynku.<br/><br/>
Specjalizacje w obszarze IT:<br/>
	• Testowanie oprogramowania — Współtworzyłem i prowadziłem liczne szkolenia z zakresu testowania, obejmujące podstawowe i zaawansowane zagadnienia. Moje doświadczenie obejmuje ponad 300 godzin szkoleń, w tym warsztaty z automatyzacji testów z użyciem Pythona, JAVY i Selenium.<br/>
	• Zarządzanie projektami IT — Aktywnie uczestniczę w projektach z obszaru IoT, automatyzacji oraz zrównoważonego zarządzania energią, takich jak Hack4Change, gdzie pełniłem funkcje mentora i prowadziłem warsztaty.<br/><br/>
Specjalizacje w obszarze druku 3D i wytwarzania:<br/>
	• Ekspert druku 3D — Prowadziłem warsztaty i prelekcje podczas licznych wydarzeń, takich jak Pomorskie Dni Druku 3D, SpinDay, czy Festiwal Światła. Moje działania obejmują zarówno popularyzację technologii wśród dzieci i młodzieży, jak i zastosowanie druku 3D w profesjonalnych projektach, takich jak rekonstrukcja dziedzictwa kulturowego z użyciem technologii cyfrowych.<br/>
	• IoT i elektronika — Wspieram innowacyjne projekty, łączące druk 3D z elektroniką oraz inteligentnymi systemami, co pozwala na tworzenie zaawansowanych rozwiązań wspierających edukację oraz rozwój przemysłowy.<br/><br/>
Kluczowe osiągnięcia:<br/>
	• Mentor podczas wydarzeń technologicznych, takich jak Hack4Change, Arduino Day itp.<br/>
	• Organizator i prowadący warsztaty z druku 3D dla dzieci, dorosłych oraz instytucji edukacyjnych.<br/>
	• Autor prelekcji dotyczących przyszłości druku 3D oraz innowacyjnych zastosowań IoT.<br/>
	• Współorganizator wydarzeń promujących zrównoważony rozwój, takich jak Festiwal Druku 3d czy Festiwal Światła.<br/><br/>
Publikacje i artykuły:<br/>
	• Autor licznych tekstów poświęconych technologii druku 3D, IoT oraz nowoczesnym metodom wytwarzania, opublikowanych m.in. na stronach PPNT, Radio Gdańsk oraz w międzynarodowych portalach edukacyjnych.<br/>
Dlaczego warto nawiązać współpracę?<br/>
Moje podejście łączy zaawansowaną wiedzę techniczną z praktycznymi umiejętnościami oraz pasję do dzielenia się wiedzą. Współpracując ze mną, zyskujesz partnera, który nie tylko zrealizuje zaawansowane projekty technologiczne, ale również pomoże Ci wdrożyć innowacyjne rozwiązania, odpowiadające na potrzeby Twojej organizacji.<br/>
Zapraszam do współpracy!`,
          title: "IT Test Manager / Test Architect / IT Test Environment Manager /  Maker",
          linkedin: "https://www.linkedin.com/in/mirosław-pałysiewicz-24a0931b",
        },
        {
          id: "jakubw",
          image: require("../Mentors/images/jakubw.png").default,
          name: "Jakub Wilczyński",
          description:
            "Absolwent wydziału Grafiki na Akademii Sztuk Pięknych w Gdańsku, specjalność Grafika Projektowa i Grafiki na PJATK w Gdańsku, gdzie obronił się z wyróżnieniem. Inż. Architektury. W PJATK prowadzi zajęcia z Liternictwa, Fotografii oraz Animacji. Obecnie pracuje jako UX i UI designer i współprowadzi studio projektowe. Z zamiłowania muzyk i akwarysta.",
          title: "Wykładowca na Wydziale Sztuki Nowych Mediów, PJATK Gdańsk",
          linkedin: " ",
        },
        {
          id: "nataliap",
          image: require("../Mentors/images/nataliap.jpg").default,
          name: "Natalia Pawlak",
          description:
            "Od czasów wczesnoszkolnych wiązała swoją przyszłość ze środowiskiem IT. Marzenie to zrealizowała studiując na Politechnice Poznańskiej na kierunku Informatyka. Swoją zawodową wędrówkę rozpoczęła kilka lat temu. Na początku było to testowanie, ale gdzieś zawsze pojawiały się stanowiska związane również z koordynacją pracy oraz zarządzaniem ludźmi. Posiada certyfikacje z zakresu testowania jak i prowadzenia projektów. Stawia na komunikatywność i indywidualne oraz grupowe docenianie współpracowników, ze wskazaniem ich mocnych stron i odpowiednim ukierunkowaniem. W swoim zespole stawia na relacje partnerskie bazujące nie tylko na autorytecie przełożonego, ale również rodzinnej atmosferze. W wolnym czasie czyta książki kryminalne lub ogląda seriale. Ponadto jak tylko pogoda pozwala wyrusza na spacery ze swoimi psiakami.\n" +
            "\nW 2020 roku razem z Karoliną Pawłowską stworzyła markę Fun with bugs. Pod tym szyldem napisały i wydały w modelu self-publishingu książkę „Podróż przez świat testowania”, która w lekki i zabawny sposób uczy testowania. Książka pomogła już setkom osób w przebranżowieniu się i wejściu do IT.",
          title: "Senior Tester at FlexDev - Future-proof Your Business",
          linkedin: "https://www.linkedin.com/in/natalia-pawlak-b9262b57/",
        },
        {
          id: "karolinap",
          image: require("../Mentors/images/karolinap.jpg").default,
          name: "Karolina Pawłowska",
          description:
            "Aktywnie działa w środowisku IT i game dev od paru ładnych lat. Pracowała w różnych firmach i zespołach przy wielkich i małych aplikacjach. Najbardziej lubi dbać o jakość, szczególnie testować eksploracyjnie i dzielić się tą pasją z innymi. Jest fanką gier planszowych i komputerowych, które także testuje wspierając w ten sposób niezależnych twórców gier.\n" +
            "\nW 2020 roku razem z Natalią Pawlak stworzyły markę Fun with bugs. Pod tym szyldem napisały i wydały w modelu self-publishingu książkę „Podróż przez świat testowania”, która w lekki i zabawny sposób uczy testowania. Książka pomogła już setkom osób w przebranżowieniu się i wejściu do IT.",
          title: "Senior QA, trenerka IT i ekspertka ds. jakości oprogramowania",
          linkedin: "https://www.linkedin.com/in/karolina-paw%C5%82owska-70558678/",
        },
        {
          id: "jaroslaww",
          image: require("../Mentors/images/jaroslaww.jpg").default,
          name: "Jarosław Wulnikowski",
          description:
            "Programista-manager z 10 letnim doświadczeniem. W trakcie swojej kariery przeszedł przez wiele organizacji (startupy, agencje marketingowe, małe i średnie firmy, korporacje). Obecnie zajmuje się budowaniem i zarządzaniem zespołami programistycznymi oraz doradzaniem firmom w zakresie procesu wytwarzania oprogramowania. Aktualnie pracuje jako Principal software engineer w S&P Global gdzie odpowiada za kilkunastoosobowy zespół programistów oraz rozwija własną firmę Cappibare, gdzie wytwarza nowoczesne strony internetowe.",
          title: "Principal Software Engineer / Team Leader w S&P Global",
          linkedin: "https://www.linkedin.com/in/jaros%C5%82aw-wulnikowski-8523a57b",
        },
        {
          id: "wojciechl",
          image: require("../Mentors/images/wojciechl.jpg").default,
          name: "Wojciech Leonowicz",
          description:
            "Wspiera startupy w ich rozwoju, aktywnie uczestnicząc w lokalnych, krajowych i międzynarodowych mechanizmach wsparcia. Brał udział w akceleracji 150+ zespołów, które pracowały z ponad 20 dużymi przedsiębiorstwami i korporacjami.",
          title: "Bridging startup tech supply with business demands",
          linkedin: "https://www.linkedin.com/in/wojciech-leonowicz-61500b145/",
        },
        {
          id: "janc",
          image: require("../Mentors/images/janc.jpg").default,
          name: "dr inż. arch. Jan Cudzik",
          description: "Jest kierownikiem badań w spółce OutlineAI zajmującej się automatyzacją procesów analiz oraz projektowania w architekturze oraz adiunktem w Katedrze Architektury Miasta i Przestrzeni Nadwodnych oraz Kierownikiem Laboratorium Cyfrowych Technologii, na Wydziale Architektury Politechniki Gdańskiej. Obecnie prowadzi szeroko zakrojone badania naukowe dotyczące między innymi architektury kinematycznej, cyfrowych technik wspomagających projektowanie architektoniczne, cyfrowej fabrykacji, form sztucznej inteligencji w architekturze i sztuce. \n",
          title: "COO in OutlineAI",
          linkedin: "https://www.linkedin.com/in/jan-cudzik/"
        },
        {
          id: "karmenr",
          image: require("../Mentors/images/Karmen Radtke.webp").default,
          name: "Karmen Radtke",
          description:
            "Na potrzebę imprez typu hackathon i gamejam opracowałam skuteczny system tworzenia prezentacji, który przyczynił się do niejednokrotnego zajęcia miejsca na podium przez mój zespół. Współpracowałam przy tworzeniu skutecznych prezentacji biznesowych pod pichte do dofinansowań. Na co dzień zajmuję się projektowaniem interfejsów i dbam o przekazywanie maksymalnej ilości informacji w najbardziej przystępny sposób. Chętnie pomogę przy tworzeniu prezentacji, podpowiem sprawdzone rozwiązania i dam feedback.",
          title: "UI & UX Designer I VR I Graphic Art Designer I Gamedev",
          linkedin: "https://www.linkedin.com/in/m-karmen-radtke/",
        },

        {
          id: "basiaj",
          image: require("../Mentors/images/basia_jagoda.jpg").default,
          name: "Basia Jagoda",
          description:
            "W branży IT działam od 2015 roku. Specjalizuję się w komunikacji technologicznych usług B2B i większość swojej pracy spędziłam, pracując w polskich software house'y lub dla agencji marketingowych i kreatywnych jako ich PRowiec. Koncentruję się na tworzeniu takich strategii komunikacji, które firma może wdrożyć od ręki i wykorzystać takie zasoby, jakimi dysponuje tu i teraz. Moim najważniejszym doświadczeniem zawodowym jest ścisła współpraca z zarządami średniej wielkości, szybko rozwijających się firm. W Linkleaders prowadzę projekty dla theprotocol.it, SAP Polska, Benefit Systems czy Polish Data Center Association.",
          title: "PR dla branży IT i startupowej",
          linkedin: "https://www.linkedin.com/in/basiajagoda/",
        },
        {
          id: "maciejb",
          image: require("../Mentors/images/maciejb.jpg").default,
          name: "Maciej Budzisz",
          description: `Specjalista w zakresie cyfrowej dostępności z pięcioletnim stażem, który przeprowadził ponad 500 przeglądów witryn internetowych i aplikacji na urządzenia mobilne.
<br/>
Absolwent wydziału Zarządzania na Akademii Morskiej w Gdyni. Poza zawodowymi obowiązkami, żywi zamiłowanie do aktywności fizycznej i nauk o zachowaniu, co odzwierciedla się w jego roli przewodniczącego w Organizacji Aktywne Kosakowo.
<br/>
Jego percepcja aspektów technicznych oraz humanistycznych w dziedzinie dostępności wynika z synergii profesjonalnych kompetencji i prywatnych zainteresowań.`,
          title: "Ekspert ds. dostępności WCAG",
          linkedin: "https://www.linkedin.com/in/budziszmaciej/",
        },
        {
          id: "lukaszk",
          image: require("../Mentors/images/lukaszk.webp").default,
          name: "Łukasz Kacprowicz",
          description: `Współzałożyciel studia animacji Grupa Smacznego / GS Animation. Prezes Zarządu Polskiego Stowarzyszenia Producentów Animacji. Doświadczony reżyser i producent związany z animacją od 2004 roku. Autor wielokrotnie nagradzanej serii „Mami Fatale”. Scenarzysta, concept artist, autor storyboardów i grafik. Wyreżyserował odcinki seriali „Basia”, „Kajko i Kokosz”, „The Very Hairy Alphabet” oraz „Historie spod podłogi”. Pełnometrażowa hiszpańsko-polska koprodukcja „Rock Bottom”, w której pełnił funkcję producenta i reżysera animacji rotoskopowej, otrzymała nominację do nagrody Goya.<br/>  
Obecnie zajmuje się nadzorem serialu telewizyjnego „Grand Banda”, opracowaniem koncepcji serialu muzycznego „Endover Groove” oraz produkcją pełnometrażowej przygodowej animacji „Wielka Księga Mami Fatale”.  `,
          title: "Reżyser, producent animacji",
          linkedin: "https://www.linkedin.com/in/lukasz-kacprowicz-73b73556/",
        },
        {
          id: "agak",
          image: require("../Mentors/images/agak.webp").default,
          name: "Aga Kotowska",
          description: `Typowy Kot. Na co dzień zajmuje się identyfikacją wizualną, typografią oraz projektami kreatywnymi. Obecnie mieszka i pracuje jako niezależna projektantka w Gdańsku. Z wykształcenia architektka krajobrazu i absolwentka studiów podyplomowych na kierunku Projektowanie Graficzne w Akademii Sztuk Pięknych w Łodzi (2015) oraz Uniwersytetu Artystycznego w Poznaniu (2023). Ukończyła również Jagielloński Kurs Typografii (2018) oraz gdańską „Sztukę Projektowania”(2017). Otrzymała wyróżnienia w konkursach: Projekt Roku STGU 2018/2019 w kategorii Świeża Krew, oraz Polish Graphic Design Awards 2018, w kategorii kroje pism. Talent Olsztyna 2017 w kategorii: projektowanie graficzne. Doświadczenie zawodowe zdobywała w agencjach reklamowych i różnych firmach jako projektantka graficzna i web designerka. W latach 2020-2022 prowadziła własne studio: Typowy Kot. Jej prace opierają się głównie na liternictwie, z którym dużo eksperymentuje zarówno cyfrowo oraz analogowo. Otwarta na nowych ludzi, eksperymenty, ciekawe inicjatywy oraz współpracę przy mądrych i wartościowych projektach.`,
          title: "Creative Designer & Art Director",
          linkedin: "https://www.linkedin.com/in/agnieszka-kotowska-584258b4/",
        },
        {
          id: "malgorzatao",
          image: require("../Mentors/images/yoga.png").default,
          name: "Małgorzata Olewniak",
          description: `Moja baza to joga metodą Iyengara, na to nakładam pracę z powięzią i taśmami anatomicznymi. Kładę duży nacisk na uważność i budowanie świadomości ciała i kontaktu z nim. Uwielbiam praktykować w naturze. Jest wtedy przestrzeń, kolor, powiew wiatru, szum drzew, śpiew ptaków, dotyk trawy, drzewa. Energia przepływa harmonizując i dostrajając się do natury. Co daje joga sama w sobie - na poziomie fizycznym większe poczucie ciała i jego kontroli, zwiększenie zakresów ruchu, utrzymanie ruchomości stawów, nasmarowanie, a przez to odczucie lekkości w ciele. A na poziomie duchowym - wyciszenie, uważność na siebie i swoje potrzeby, świadomość ciała i otoczenia. Można mnie znaleźć w Gdańsku na Chełmie i Oruni.`,
          title: "Nauczycielka jogi, matka, odkrywca, poszukiwaczka",
          linkedin: "https://www.facebook.com/jogowaga",
        },
        {
          id: "robertj",
          image: require("../Mentors/images/robertj.webp").default,
          name: "Robert Jaszczurowski",
          description: `Producent i reżyser animacji, współtwórca gdańskiego studia Grupa Smacznego / GS Animation. Od ponad dwóch dekad tworzy seriale i filmy animowane dla dzieci i dorosłych – m.in. Basię, Mami Fatale, Kajko i Kokosza czy rockowy musical Rock Bottom. Jego projekty zdobywały nagrody na festiwalach w Polsce i za granicą, trafiały do telewizji, serwisów streamingowych i serc widzów. Jako były prezes Stowarzyszenia Producentów Polskiej Animacji i aktywny członek SFP działa na rzecz rozwoju polskiej animacji. Z przyjemnością dzieli się doświadczeniem – prowadząc warsztaty, wykłady i wspierając młodych twórców.`,
          title: "Animation producer at GS ANIMATION // Grupa Smacznego",
          linkedin: "https://www.linkedin.com/in/robert-jaszczurowski-a4673616/",
        },
        {
          id: "kamilak",
          image: require("../Mentors/images/kamilak.webp").default,
          name: "Kamila Kokot",
          description: `Kamila Kokot-Kanikuła pracuje w Bibliotece Politechniki Gdańskiej w Sekcji Budowy Zbiorów Cyfrowych i Multimedialnych. Jest absolwentką Instytutu Historycznego oraz Informacji Naukowej i Bibliotekoznawstwa na Uniwersytecie Wrocławskim. Główne kierunki zainteresowań to starodruki, biblioteki cyfrowe, repozytoria instytucjonalne, Otwarte Zasoby Edukacyjne, Open Access i Open Data. W bibliotece Kamila pracuje na rzecz Pomorskiej Biblioteki Cyfrowej i współtworzy bazę polityk wydawniczych polskich czasopism naukowych znajdującą się na platformie MOST Wiedzy. Od kwietnia 2019 r. jest członkiem międzynarodowego zespołu ds. promocji Otwartych Zasobów Edukacyjnych: European Network of Open Education Librarians. W lipcu 2024 r. dołaczyła do zespołu wolontariuszy w bazie Directory of Open Access Journals (DOAJ), jako Associate Editor. Jej głównym celem jako bibliotekarki i wolontariuszki jest wspieranie społeczności akademickiej w efektywnym znajdowaniu takich źródeł naukowych, które ułatwiają prowadzenie wartościowych i rzetelnych badań.`,
          title: "University Librarian at Gdańsk University of Technology",
          linkedin: "https://www.linkedin.com/in/kamila-kokot/",
        },

        {
          id: "lukaszn",
          image: require("../Mentors/images/lukasz_nowacki.webp").default,
          name: "Łukasz Nowacki",
          description: `Łukasz Nowacki – doświadczony konsultant ds. strategii i sztucznej inteligencji, z silnym zapleczem w zarządzaniu i rozwoju biznesu. Obecnie związany z firmą Neoteric, gdzie wspiera klientów w tworzeniu i wdrażaniu innowacyjnych rozwiązań technologicznych. Łukasz łączy analityczne podejście z praktycznym doświadczeniem, pomagając organizacjom rozwijać się i skutecznie wykorzystywać nowe technologie. Po godzinach rozwija własne inicjatywy biznesowe.`,
          title: "Chief Delivery Officer",
          linkedin: "https://www.linkedin.com/in/lnowacki/",
        },
        {
          id: "annam",
          image: require("../Mentors/images/annam.jpg").default,
          name: "Anna Mania",
          description: `Pracownik Wydziału Działalności Gospodarczej i Rolnictwa Urzędu Miasta Poznania, koordynator programu Plus Jeden Poznań. Od kilku lat zaangażowana w pracę na rzecz wspierania przedsiębiorczości, zarówno w zakresie biznesu tradycyjnego, jak i firm technologicznych. Prowadzi i organizuje szkolenia dla przedsiębiorców oraz osób planujących rozpoczęcie działalności gospodarczej, zajmuje się także doradztwem biznesowym.  Od lat współpracuje z wieloma poznańskimi instytucjami wsparcia biznesu, promując przedsiębiorczość i przedsiębiorców. 
Prywatnie wielka fanka skandynawskich seriali.`,
          title: "Koordynator programu Plus Jeden Poznań",
          linkedin: "https://www.linkedin.com/in/anna-mania-4a92941b7/",
        },
        {
          id: "ewelinas",
          image: require("../Mentors/images/ewelinas.jpg").default,
          name: "Ewelina Skowron",
          description: `CEO & Co-Founder w startupie youbloom, Mobile Engineer, Ambasadorka Women Techmakers, organizatorka GDG Poznań oraz mentorka. Łączy technologie z misją społeczną, promując rozwiązania wspierające zdrowie psychiczne oraz świadome dbanie o siebie. Pasjonuje się budowaniem autentycznych społeczności oraz wspieraniem ludzi w rozwoju osobistym i zawodowym.`,
          title: "CEO & Mobile Engineer",
          linkedin: "https://www.linkedin.com/in/ewelinaskowron/",
        },
        {
          id: "marcinz",
          image: require("../Mentors/images/marcinz.webp").default,
          name: "Marcin Żuliński",
          description: `Jestem pasjonatem automatyzacji i robotyzacji – wierzę, że szkoda życia na wykonywanie czynności, które da się zautomatyzować. Od 6 lat zawodowo zajmuję się Robotic Process Automation (RPA), obecnie w branży logistycznej dla Hapag-Lloyd. Karierę zaczynałem jako likwidator szkód w ubezpieczeniach, gdzie automatyzacja szybko stała się moim naturalnym narzędziem pracy. Przez 4 lata pracowałem także jako IT Project Manager. Z wykształcenia geograf, z zamiłowania podróżnik, DJ i producent muzyczny.`,
          title: "Robotic Process Automation Developer and Dev Lead",
          linkedin: "https://www.linkedin.com/in/marcin-%C5%BCuli%C5%84ski-71a2a5122/",
        },
        {
          id: "monikao",
          image: require("../Mentors/images/monikao.webp").default,
          name: "Monika Ostapczuk",
          description: `Rozwój biznesu | Coaching | Mentoring | Zarządzanie zmianą | Szkolenia<br/><br/>

Ekspertka w dziedzinie zarządzania i psychologii biznesu, z 20-letnim doświadczeniem w sprzedaży. Od 11 lat zarządza zespołami sprzedażowymi w sektorze małych i średnich przedsiębiorstw. Tworzy i wdraża strategie sprzedażowe, dopasowane do specyfiki działalności Klienta. Motywuje, a także pomaga w stawianiu i osiąganiu ambitnych celów biznesowych, zarówno firmom, jak i Klientom indywidualnym, budując biznes od podstaw, a także wspomagając go na każdym etapie działania.<br/><br/>

Obecnie współtworzy markę Yellow Tie, której misją jest wspieranie Klientów w osiąganiu ich pełnego potencjału poprzez dostarczanie inspirujących, merytorycznych szkoleń, doradztwa i usług wspomagających. Wraz z innymi ekspertami w firmie angażuje się w rozwijanie talentów, dostosowywanie strategii oraz tworzenie innowacyjnych rozwiązań, które napędzają rozwój i przynoszą wymierne korzyści.`,
          title: "Dyrektor ds. Rozwoju i Relacji Biznesowych",
          linkedin: "https://www.linkedin.com/in/monika-ostapczuk/",
        },
        {
          id: "malwinapk",
          image: require("../Mentors/images/malwinapk.webp").default,
          name: "Malwina Puchalska-Kamińska",
          description: `dr Malwina Puchalska-Kamińska, psycholożka, pracuje na Uniwersytecie SWPS w Sopocie. Zajmuje się badawczo i popularyzatorsko tematyką dobrostanu, analizując jego wpływ na funkcjonowanie jednostek i społeczności, a także opracowując praktyczne narzędzia wspierające jego rozwój w różnych kontekstach, w tym w edukacji i w pracy. Autorka publikacji naukowych i popularnonaukowych w obszarze Psychologii Pracy i Organizacji oraz Psychologii Pozytywnej.`,
          title: "Adiunktka Uniwersytet SWPS",
          linkedin: "https://www.linkedin.com/in/malwina-puchalska-kamińska-phd-906b9988/",
        },
        {
          id: "bartoszs",
          image: require("../Mentors/images/bartoszs.webp").default,
          name: "Bartosz Skelnik",
          description: `Bartosz Skelnik – ekspert od elektroniki i embedded, który od ponad 12 lat zamienia pomysły w seryjnie produkowane urządzenia elektroniczne. Pracuje według zasady „Minimum Viable Test przed MVP”. Projektuje tak, by błyskawicznie zwalidować model biznesowy, a jednocześnie zachować elastyczność dalszego rozwoju. Pokazuje, jak połączyć PCB, firmware i proces certyfikacji z realiami rynku. Pomaga układać procesy oraz budować zespoły R&D, które w duchu Agile i najlepszych praktyk konsekwentnie dowożą wyniki. Na co dzień zarządza międzynarodową firmą technologiczną tworzącą wyspecjalizowane urządzenia medyczne.`,
          title: "CEO ICU tech / Catboat Strings",
          linkedin: "https://www.linkedin.com/in/bartosz-skelnik/",
        },


        {
          id: "arkadiusz",
          image: require('../Mentors/images/rsz_a_kwoska.jpg').default,
          name: "Arkadiusz Kwoska",
          description: "Od prawie 20 lat współtworzy innowacyjne systemy informatyczne optymalizujące i wspierające efektywność działań Klientów i współpracowników. Pracował zarówno z korporacjami jak i z małymi przedsiębiorcami z Polski, Europy i Doliny Krzemowej. Obecnie wspiera zaspokajanie realnych potrzeb biznesowych dużych przedsiębiorstw w ramach największych w Polsce programów akceleracyjnych i wdrożeniowych, oraz rozwój przedsiębiorstw technologicznych w ramach działalności prowadzonej przez Rebels Valley. Jest Partnerem w funduszu inwestycyjnym NXT Ventures inwestującym w innowacyjne podmioty z branży ICT oraz nowych materiałów. W ramach programów doradczych i warsztatów dzieli się z przedsiębiorcami swoją wiedzą i doświadczeniem w zakresie prowadzenia, rozwoju i optymalizacji biznesu bazując na mierzalnych kryteriach.",
          title: "CEO, Rebels Valley",
          linkedin: "https://www.linkedin.com/in/akwoska/",
        },
        {
          id: "bd",
          image: require('../Mentors/images/blazejd.jpg').default,
          name: "Błażej	Dziuk",
          description: `Organizator i twórca Pomorskiego Hubu dla Startupów - Startup Harbour. Marketer z pasji, sprzedawca z powołania. Pomaga wtedy gdy rozwiązania "logiczne" przestają przynosić rezultaty.`,
          title: "Startup Harbour	Co-Founder / marketing",
          linkedin: "https://www.linkedin.com/in/blazej-dziuk/",
        },
      ]
    },
    workshops2025: {
      title: "Warsztaty 2025",
      description: "Przed hackathonem Hack4Change odbyła się seria warsztatów, które pomogły uczestnikom przygotowac się do udziału w wydarzeniu. Zobacz co udało nam się zorganizować!",
      button: "Dowiedz się więcej &rarr;",
      workshops: [
        {
          id: "1",
          mentorId: "jw",
          image: require("../Mentors/images/jakubw.png").default,
          name: "mgr inż. Jakub Wilczyński",
          title: "Wykładowca na Wydziale Sztuki Nowych Mediów, PJATK Gdańsk",
          description: "Figma to potężne narzędzie, które możne ułatwić tworzenie aplikacji i szybkich prototypów. To szczególnie cenna umiejętność na hackathonie. Warsztaty poprowadzi Jakub Wilczyński - wykładowca na Wydziale Sztuki Nowych Mediów, PJATK Gdańsk. Jakub Będzie także mentorem podczas hackathonu.",
          fullDescription: `"Warsztaty projektowania aplikacji w Figmie" rozpoczną się od wprowadzenia do interfejsu i podstawowych funkcji tego narzędzia do projektowania. Uczestnicy dowiedzą się, jak współpracować w czasie rzeczywistym na jednym projekcie, co umożliwia łatwą komunikację i synchronizację zespołu projektowego. Warsztaty obejmą następujące zagadnienia:
<br/><br/>
"Frame" jako podstawowa jednostka konstrukcyjna, pozwalająca na tworzenie responsywnych i zorganizowanych układów.
<br/><br/>
Wykorzystanie siatek, wierszy i kolumn do precyzyjnego rozmieszczania elementów zapewnia spójność i estetykę projektu. Uczestnicy nauczą się, jak konfigurować i dostosowywać te siatki, aby odpowiadały ich potrzebom projektowym.
<br/><br/>
"Smart Animate", która umożliwia tworzenie płynnych przejść między ekranami i elementami interfejsu.
<br/><br/>
"Auto Layout" pozwala na automatyczne dostosowywanie rozmiaru i położenia elementów, co jest szczególnie przydatne przy projektowaniu responsywnych interfejsów.`,
          workshop: "Warsztaty projektowania aplikacji w Figmie",
          date: `23.06 (poniedziałek) 18:00, Online - <a href="https://us06web.zoom.us/j/7728967652?pwd=llpb0pZw22O9AILwV9PH2YtIoAGzGe.1">https://us06web.zoom.us/j/7728967652?pwd=llpb0pZw22O9AILwV9PH2YtIoAGzGe.1</a>`,
          tutorDesc: "Absolwent wydziału Grafiki na Akademii Sztuk Pięknych w Gdańsku, specjalność Grafika Projektowa i Grafiki na PJATK w Gdańsku, gdzie obronił się z wyróżnieniem. Inż. Architektury. W PJATK prowadzi zajęcia z Liternictwa, Fotografii oraz Animacji. Obecnie pracuje jako UX i UI designer i współprowadzi studio projektowe. Z zamiłowania muzyk i akwarysta.",
          linkedin: " "
        },
        {
          id: "2",
          mentorId: "ek",
          image: require("../Mentors/images/Ewa Kryger.jpg").default,
          name: "Ewa Kryger",
          title: "Delivery Management in AI | TOP100 Women in Data Science | Project Management | Team-building Facilitation | Art Meditation | AI Ethics | Art Tech",
          description: " ",
          fullDescription: `Zatrzymaj się na chwilę. Weź oddech. Poczuj, że jesteś.
W trakcie godzinnych warsztatów uczestnicy Hack4Change będą mieli okazję zwolnić tempo, wyciszyć umysł i skontaktować się ze swoim ciałem poprzez świadomy oddech i prostą medytację relaksacyjną.
To przestrzeń dla każdego – bez oczekiwań, bez konieczności przygotowania. Wystarczy być.<br/><br/>


Cele:<br/><br/>
- Nauka prostych technik oddechowych do redukcji napięcia i poprawy koncentracji,<br/>
- Pogłębienie kontaktu z ciałem i wrażeniami zmysłowymi,<br/>
- Wprowadzenie do praktyki medytacyjnej – jako narzędzia wspierającego uważność i kreatywność.<br/><br/>




1. Wprowadzenie<br/>
Krótka rozmowa o roli oddechu i obecności w codziennym funkcjonowaniu – zwłaszcza w środowisku wysokiej aktywności intelektualnej, takim jak hackathon.

<br/><br/>
2. Ciało i oddech – ćwiczenia praktyczne<br/>
- Świadome skanowanie ciała (body scan) w pozycji siedzącej,<br/>
- Ćwiczenia oddechowe (np. oddech 4–7–8, oddech przez nos, świadomy wydech),<br/>
- Proste ruchy pogłębiające kontakt z ciałem.<br/><br/>


3. Sesja relaksacyjno-medytacyjna<br/>
- Prowadzona medytacja z naciskiem na oddech i ugruntowanie w ciele,<br/>
- Doświadczenie „bycia” bez działania – jako forma regeneracji i powrotu do siebie.<br/><br/>


4. Zakończenie<br/>
- Podsumowanie: jak praktykować samodzielnie?<br/>
- Otwarte pytania, dzielenie się doświadczeniami (opcjonalnie).<br/><br/>




Materiały potrzebne:<br/>
- Kocyk / mata / coś wygodnego do siedzenia (uczestnicy przynoszą sami),<br/>
- Naturalna przestrzeń (plaża / park – cicha, przyjazna, bez krzeseł).<br/><br/>


Dla kogo:<br/><br/>


Dla każdego uczestnika hackathonu, który potrzebuje momentu zatrzymania – bez względu na poziom doświadczenia z medytacją czy oddechem.
`,
          workshop: "Oddech i Obecność",
          date: "29.06 (niedziela) 9:00 - 10:00",
          tutorDesc: "Dociekliwa specjalistka Data Science oraz artystka. Z wykształcenia urbanistka i filozofka. Wiele lat pracowała przy projektach planistycznych, partycypacyjnych i edukacyjnych. Skupia się głównie na wizualizacji i analizie procesów zarówno biznesowych, jak i społecznych. Dodatkowo bardzo ważna jest dla niej praca społeczna i wykorzystanie nowych technologii w zakresie AI for Good. Aktywnie działa w obszarze 3 sektora, współzałożycielka WiMLDS (Women in Machine Learning & Data Science) Trójmiasto. Założycielka Fundacji Art Hacks AI, której główną misją będzie tłumaczenie zagadnień związanych z nowymi technologiami, językiem emocji poprzez sztukę. W wolnym czasie, gdy nie czyta, to maluje, zwiedza świat na rowerze oraz tworzy muzykę.",
          linkedin: "https://www.linkedin.com/in/ewakryger/"
        },
        {
          id: "3",
          mentorId: "ln",
          image: require("../Mentors/images/lukasz_nowacki.webp").default,
          name: "Łukasz Nowacki",
          title: "Chief Delivery Officer",
          description: " ",
          fullDescription: `Praktyczne warsztaty pokazujące, jak w ekspresowym tempie stworzyć działający prototyp aplikacji. Nauczysz się podstawowych technik szybkiego prototypowania i poznasz narzędzia, które pozwolą Ci zamienić pomysł w działający projekt w zaledwie 10 minut.`,
          workshop: "Vibe Coding - jak stworzyć prototyp aplikacji w 10 minut?",
          date: `23.06 (poniedziałek) 17:00 Online - <a href="https://us06web.zoom.us/j/7728967652?pwd=llpb0pZw22O9AILwV9PH2YtIoAGzGe.1">https://us06web.zoom.us/j/7728967652?pwd=llpb0pZw22O9AILwV9PH2YtIoAGzGe.1</a>`,
          tutorDesc: "Łukasz Nowacki – doświadczony konsultant ds. strategii i sztucznej inteligencji, z silnym zapleczem w zarządzaniu i rozwoju biznesu. Obecnie związany z firmą Neoteric, gdzie wspiera klientów w tworzeniu i wdrażaniu innowacyjnych rozwiązań technologicznych. Łukasz łączy analityczne podejście z praktycznym doświadczeniem, pomagając organizacjom rozwijać się i skutecznie wykorzystywać nowe technologie. Po godzinach rozwija własne inicjatywy biznesowe.",
          linkedin: "https://www.linkedin.com/in/lnowacki/"
        },
        {
          id: "4",
          mentorId: "mb",
          image: require("../Mentors/images/maciejb.jpg").default,
          name: "Maciej Budzisz",
          title: "Ekspert ds. dostępności WCAG",
          description: " ",
          fullDescription: `Podczas warsztatów poznamy podstawowe zasady projektowania i tworzenia dostępnych rozwiązań cyfrowych. Omówimy najważniejsze wytyczne WCAG, praktyczne narzędzia do testowania dostępności oraz dobre praktyki, które każdy twórca aplikacji powinien znać. Warsztaty mają charakter praktyczny - uczestnicy będą mogli sprawdzić dostępność swoich projektów.`,
          workshop: "Dostępność cyfrowa - podstawy dla twórców aplikacji i stron internetowych",
          date: "25.06 (środa) 18:00",
          tutorDesc: `Specjalista w zakresie cyfrowej dostępności z pięcioletnim stażem, który przeprowadził ponad 500 przeglądów witryn internetowych i aplikacji na urządzenia mobilne.
<br/><br/>
Absolwent wydziału Zarządzania na Akademii Morskiej w Gdyni. Poza zawodowymi obowiązkami, żywi zamiłowanie do aktywności fizycznej i nauk o zachowaniu, co odzwierciedla się w jego roli przewodniczącego w Organizacji Aktywne Kosakowo.
<br/><br/>
Jego percepcja aspektów technicznych oraz humanistycznych w dziedzinie dostępności wynika z synergii profesjonalnych kompetencji i prywatnych zainteresowań.`,
          linkedin: "https://www.linkedin.com/in/budziszmaciej/"
        },
        {
          id: "5",
          mentorId: "as",
          image: require("../Mentors/images/annas.webp").default,
          name: "Anna Supernat",
          title: "Naukowiec, Kierownik Centrum Analiz Biostatystycznych i Bioinformatycznych",
          description: " ",
          fullDescription: `Warsztaty poświęcone będą kulisom zarządzania projektem <strong>NeuroMapa</strong>, którego celem jest identyfikacja i promowanie miejsc przyjaznych neuroróżnorodności – szczególnie dla dzieci i młodzieży ze spektrum autyzmu czy ADHD. Chociaż skupimy się na samym projekcie i jego celach, główny nacisk zostanie położony na to, <strong>jak zaplanować, koordynować i skutecznie wdrażać inicjatywę o dużym zasięgu społecznym.</strong><br/>
        <br/>Uczestnicy poznają kolejne etapy zarządzania projektem:<br/><br/>
        - <strong>Inicjacja projektu:</strong> od pomysłu do zdefiniowania misji, celów i kluczowych potrzeb środowiska osób neuroatypowych. W tym etapie skupimy się na analizie problemu, definiowaniu interesariuszy oraz formułowaniu strategii działań.<br/>
        - <strong>Planowanie:</strong> jak tworzyć harmonogram działań, zarządzać zasobami i dobierać zespół projektowy o interdyscyplinarnych kompetencjach (psycholodzy, pedagodzy, projektanci, lokalne instytucje).<br/>
        - <strong>Realizacja i koordynacja:</strong> jak efektywnie przeprowadzać badania terenowe, zbierać dane o przestrzeniach publicznych i prywatnych (muzea, kina, restauracje), a także jak wdrażać działania promujące dobre praktyki (np. ciche godziny, przeszkolony personel, odpowiednie oznakowanie).<br/>
        - <strong>Zarządzanie komunikacją:</strong> jak budować narrację projektu w przestrzeni publicznej i prowadzić kampanie edukacyjne zwiększające świadomość społeczną na temat neuroróżnorodności.<br/>
        - <strong>Monitorowanie i ewaluacja:</strong> jak oceniać efektywność projektu i na bieżąco dostosowywać działania do zmieniających się potrzeb oraz zbieranych danych.<br/><br/>
        Uczestnicy dowiedzą się również, jak budować zaangażowanie społeczności, współpracować z lokalnymi partnerami i prezentować projekt w sposób atrakcyjny dla różnych grup odbiorców.<br/><br/>
        Warsztat skierowany jest do osób zainteresowanych projektami społecznymi, psychologią, edukacją oraz zarządzaniem inicjatywami międzysektorowymi. Będzie to okazja do nauki nie tylko o projekcie NeuroMapa, ale również o uniwersalnych zasadach prowadzenia projektów społecznych z realnym wpływem na jakość życia lokalnych społeczności.`,
          workshop: "Warsztaty zarządzania projektem NeuroMapa – od idei do wdrożenia",
          date: "25.06 (środa) 19:00",
          tutorDesc: `Dr hab. Anna Supernat - Liderka grupy badawczej w Zakładzie Onkologii Translacyjnej Gdańskiego Uniwersytetu Medycznego
Kierownik Centrum Analiz Biostatystycznych i Bioinformatycznych Gdańskiego Uniwersytetu Medycznego
Dr hab. Anna Supernat jest absolwentką Międzyuczelnianego Wydziału Biotechnologii Uniwersytetu Gdańskiego i Gdańskiego Uniwersytetu Medycznego, gdzie uzyskała stopień naukowy doktora w Zakładzie Biologii Komórki pod opieką prof. Anny Żaczek. Staż podoktorski odbyła w latach 2015–2016 w Cancer Research UK Cambridge Institute (University of Cambridge), a następnie udała się na miesięczny staż badawczy w Cancer Center Amsterdam (Amsterdam UMC).
Głównym obszarem badań Anny Supernat są płynne biopsje w nowotworach, ze szczególnym uwzględnieniem raka jajnika, z naciskiem na poprawę diagnostyki i monitorowania postępu choroby. Zespół działający w Zakładzie Onkologii Translacyjnej Gdańskiego Uniwersytetu Medycznego wykorzystuje najnowocześniejsze, wysokoporzepustowe techniki biologii molekularnej do analizy próbek od pacjentów. Coraz większe znaczenie w analizie tak wielowymiarowych danych odgrywa uczenie maszynowe, a prowadzone badania dynamicznie rozwijają się w kierunku multiomiki, by uchwycić pełniejszy obraz biologii nowotworów.
Anna Supernat ściśle współpracuje z zespołami naukowymi z University of Utah (USA) oraz Cancer Center Amsterdam (Holandia). Była ekspertem Narodowego Centrum Badań i Rozwoju w latach 2018–2019 oraz analitykiem genetycznym w firmie MNM Diagnostics Sp. z o.o. w 2019 roku. Jest laureatką licznych nagród i stypendiów, w tym: Stypendium START oraz STAŻE Fundacji na rzecz Nauki Polskiej, Grantu Darboven Idee Grant, Stypendium Ministra Nauki i Szkolnictwa Wyższego, a także programów POMOST i Innodoktorant. Kierowała grantami NCN Sonata oraz NCBiR Lider, a także reprezentowała Gdański Uniwersytet Medyczny w finansowanym przez UE konsorcjum EIT HEI „innovAId”, którego celem było rozwijanie kompetencji przedsiębiorczych w dziedzinie medycyny cyfrowej.
Jest współautorką 33 recenzowanych publikacji naukowych, 2 artykułów popularnonaukowych oraz 2 rozdziałów w książkach. Prywatnie – mama trzech fantastycznych synów i pasjonatka przygód, zarówno naukowych, jak i życiowych.`,
          linkedin: "https://pl.linkedin.com/in/anna-supernat-61749891"
        },

        {
          id: "6",
          mentorId: "am",
          image: require("../Mentors/images/rsz_coming_soon.png").default,
          name: "Antoni Michnik",
          title: " ",
          description: " ",
          fullDescription: `
        W trakcie Hack4change odbywać się będzie realizowany przez Hevelianum warsztat-spacer dźwiękowy z Antonim Michnikiem wokół fonosfery Brzeźna. <br/><br/>
        Pierwszy z trzech spacerów dźwiękowych po Brzeźnie. Podczas pierwszego spaceru wsłuchamy się w przyrodnicze elementy współczesnego pejzażu dźwiękowego Brzeźna, uruchamiając wyobraźnię dźwiękową w celu usłyszenia tego jak Brzeźno brzmiało w przeszłości. Skupimy się na sezonowym wymiarze brzmień przyrody: jak pejzaże dźwiękowe przyrody Brzeźna zmieniają się w ciągu roku? Z drugiej strony - czy opozycja przyroda-kurort na pewno jest taka oczywista? Porozmawiamy o tym jak przyrodnicze zmiany oraz działalność administracji miejskiej ukształtowały przyrodę Brzeźna oraz jego pejzaż dźwiękowy w ciągu XIX wieku - i jakie ma to konsekwencje do dzisiaj. Podczas spaceru nie zabraknie ćwiczeń słuchania pogłębionego i audialnej uważności.
<br/><br/>

Letni cykl spacerów dźwiękowych po Brzeźnie. Uważne nasłuchiwanie współczesnej audiosfery oraz różne ćwiczenia słuchania pogłębionego i wyobraźni dźwiękowej będą stanowić punkty wyjścia do namysłu nad różnymi przemianami audiosfery - zarówno tymi sezonowo-cyklicznymi, jak i tymi historycznymi. Współczesne dźwięki i brzmienia będą zatem stanowić odniesienie dla tego co wiemy
o brzmieniach przeszłości. Całość spina splot refleksji nad ekologią akustyczną oraz poszukiwanie zrozumienia nie tylko jak w przeszłości Brzeźno brzmiało - lecz również jak go słuchano.

<br/><br/>
Kolejne Nasłuchiwania już 26 lipca i 23 sierpnia, do zobaczenia!
<br/><br/>
Szczegółowe informacje i bezpłatne zapisy pod linkiem:
<br/><br/>

<a href="https://app.evenea.pl/event/899539-17" target="_blank">https://app.evenea.pl/event/899539-17</a>

`,
          workshop: "Poza sezonem? Uważne słuchanie i sezonowość pejzażu dźwiękowego | Nasłuchiwanie Brzeźna",
          date: "28.06 (sobota) 13:00",
          tutorDesc: ` `,
          linkedin: " "
        },
        {
          id: "7",
          mentorId: "mb",
          image: require("../Mentors/images/mateuszb.jpg").default,
          name: "Mateusz Bartoszewski",
          title: "Specjalista ds. Edukacji Ekologicznej w Hevelianum",
          description: " ",
          fullDescription: `Podczas spaceru na terenach Domu Zdrojowego oraz Parku Brzeźnieńskiego poznamy rośliny, których sekretne właściwości zapewniły im trwałe miejsce w folklorze. Odkryjemy rolę roślin w dawnych wierzeniach, obrzędach i legendach. Odpowiemy sobie między innymi na pytanie gdzie mieszka bajstruk, po co biegano z płonącą brzozą, co chroniło przed złymi mocami oraz w jaki sposób warzono eliksiry miłosne.`,
          workshop: `„Folkowe rośliny”`,
          date: " 29.06 (niedziela) 9:00 - 10:00",
          tutorDesc: `Mateusz Bartoszewski, absolwent Wydziału Biologii UG.
Z wykształcenia biolog-parazytolog, który zgłębiał tajniki życia kleszczy. Obecnie zawodowo związany z Hevelianum, gdzie zajmuje się popularyzacją nauki i edukacją ekologiczną. W swojej pracy szczególnie mocno przygląda się przyrodzie Góry Gradowej i gdańskiego Brzeźna, a w kręgu jego największych zainteresowań znajdują się owady, rosnące tam „chwasty” i wodne stworzenia, które można spotkać w akwariach Hevelianum. W wolnych chwilach zwiedza inne światy podczas sesji RPG, wytęża mózg podczas grania w planszówki lub relaksuje się malując figurki do wyżej wymienionych.`,
          linkedin: "https://www.linkedin.com/in/mateusz-bartoszewski-296b81197/"
        },
        {
          id: "9",
          mentorId: "yoga",
          image: require("../Mentors/images/yoga.png").default,
          name: "Gosia Olewniak",
          title: "Nauczycielka jogi, matka, odkrywca, poszukiwaczka",
          description: "Zajęcia jogi, relaksu i oddychania poprowadzi Gosia Olewniak - nauczycielka jogi, matka, odkrywca, poszukiwaczka :)",
          fullDescription: `Zajęcia jogi, relaksu i oddychania poprowadzi Gosia Olewniak - nauczycielka jogi, matka, odkrywca, poszukiwaczka :) <br/><br/><strong>Prosimy o zabranie własnych mat do jogi :)</strong>`,
          workshop: "Joga",
          date: "28.06 (sobota) 9:00 - 10:00",
          tutorDesc: "Moja baza to joga metodą Iyengara, na to nakładam pracę z powięzią i taśmami anatomicznymi. Kładę duży nacisk na uważność i budowanie świadomości ciała i kontaktu z nim.\n" +
            "Uwielbiam praktykować w naturze. Jest wtedy przestrzeń, kolor, powiew wiatru, szum drzew, śpiew ptaków, dotyk trawy, drzewa. Energia przepływa harmonizując i dostrajając się do natury.\n" +
            "Co daje joga sama w sobie - na poziomie fizycznym większe poczucie ciała i jego kontroli, zwiększenie zakresów ruchu, utrzymanie ruchomości stawów, nasmarowanie, a przez to odczucie lekkości w ciele.\n" +
            "A na poziomie duchowym - wyciszenie, uważność na siebie i swoje potrzeby, świadomość ciała i otoczenia.\n" +
            "Można mnie znaleźć w Gdańsku na Chełmie i Oruni\n",
          linkedin: "https://www.facebook.com/jogowaga"
        },
      ]
    },
    
  }
}
